import { render } from "./FacturacionListadoAlbaran.vue?vue&type=template&id=38a1126b&scoped=true"
import script from "./FacturacionListadoAlbaran.vue?vue&type=script&lang=js"
export * from "./FacturacionListadoAlbaran.vue?vue&type=script&lang=js"

import "./FacturacionListadoAlbaran.vue?vue&type=style&index=0&id=38a1126b&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a1126b"]])

export default __exports__